export default __webpack_public_path__ + "static/pricing-7f0433d772f5edf93fb872b8c576c732.svg";